import {
  CANCEL_ONBOARDING,
  CLEAR_ONBOARDING_FORM_BY_ID,
  CLEAR_ONBOARDING_LIST,
  CLEAR_ONBOARDING_SUBMISSION,
  CREATE_COMPOSITE_INPUT_ELEMENT,
  CREATE_FORM_ACTION_ELEMENT,
  CREATE_FORM_INPUT_ELEMENT,
  CREATE_ONBOARDING_SUBMISSION,
  EDIT_FORM_INPUT_ELEMENT,
  GET_DIRECTORY,
  GET_ONBOARDING_ALL,
  GET_ONBOARDING_BY_ID,
  GET_ONBOARDING_FORM_BY_ID,
  GET_ONBOARDING_FORMS,
  GET_ONBOARDING_TEMPLATES,
  START_ONBOARDING_EDIT,
  STOP_ONBOARDING_EDIT,
  DELETE_ATTACHED_DOCUMENTS,
} from './onboardingActionTypes';

const initialState = {
  onboardingList: null,
  onboardingById: null,
  onboardingForms: null,
  onboardingTemplates: null,
  onboardingFormById: null,
  uploadDocs: {},
  isEditing: false,
  loadingCount: 0,
  isLoading: false,
  directory: null,
};

export const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ONBOARDING_ALL.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case GET_ONBOARDING_ALL.SUCCESS:
      return {
        ...state,
        onboardingList: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case GET_ONBOARDING_ALL.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case GET_ONBOARDING_BY_ID.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case GET_ONBOARDING_BY_ID.SUCCESS:
      return {
        ...state,
        onboardingById: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case GET_ONBOARDING_BY_ID.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

      case CLEAR_ONBOARDING_FORM_BY_ID.ACTION:
      return {
        ...state,
        onboardingById: null,
      };

      case CLEAR_ONBOARDING_SUBMISSION.ACTION:
      return {
        ...state,
        onboardingById: null,
      };

      case CLEAR_ONBOARDING_LIST.ACTION:
      return {
        ...state,
        onboardingList: null,
      };

    case GET_ONBOARDING_FORMS.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case GET_ONBOARDING_FORMS.SUCCESS:
      return {
        ...state,
        onboardingForms: {...state.onboardingForms, [action.payload.path]: action.payload.data},
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };
    case GET_ONBOARDING_FORMS.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case GET_ONBOARDING_TEMPLATES.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case GET_ONBOARDING_TEMPLATES.SUCCESS:
      return {
        ...state,
        onboardingTemplates: {...state.onboardingTemplates, [action.payload.path]: action.payload.data},
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };
    case GET_ONBOARDING_TEMPLATES.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case GET_ONBOARDING_FORM_BY_ID.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case GET_ONBOARDING_FORM_BY_ID.SUCCESS:
      return {
        ...state,
        onboardingFormById: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case GET_ONBOARDING_FORM_BY_ID.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case CREATE_ONBOARDING_SUBMISSION.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case CREATE_ONBOARDING_SUBMISSION.SUCCESS:
      return {
        ...state,
        onboardingById: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };
    
    case CREATE_ONBOARDING_SUBMISSION.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case START_ONBOARDING_EDIT.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case START_ONBOARDING_EDIT.SUCCESS:
      return {
        ...state,
        isEditing: true,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case START_ONBOARDING_EDIT.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case STOP_ONBOARDING_EDIT.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case STOP_ONBOARDING_EDIT.SUCCESS:
      return {
        ...state,
        isEditing: false,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case STOP_ONBOARDING_EDIT.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case DELETE_ATTACHED_DOCUMENTS.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case DELETE_ATTACHED_DOCUMENTS.SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case DELETE_ATTACHED_DOCUMENTS.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case CREATE_FORM_INPUT_ELEMENT.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case CREATE_FORM_INPUT_ELEMENT.SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case CREATE_FORM_INPUT_ELEMENT.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case EDIT_FORM_INPUT_ELEMENT.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case EDIT_FORM_INPUT_ELEMENT.SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case EDIT_FORM_INPUT_ELEMENT.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case CREATE_COMPOSITE_INPUT_ELEMENT.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case CREATE_COMPOSITE_INPUT_ELEMENT.SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case CREATE_COMPOSITE_INPUT_ELEMENT.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case CREATE_FORM_ACTION_ELEMENT.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case CREATE_FORM_ACTION_ELEMENT.SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case CREATE_FORM_ACTION_ELEMENT.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case GET_DIRECTORY.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case GET_DIRECTORY.SUCCESS:
      return {
        ...state,
        directory: {...state.directory, [action.payload.name]: action.payload.data},
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case GET_DIRECTORY.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    case CANCEL_ONBOARDING.REQUEST:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: state.loadingCount + 1 > 0,
      };

    case CANCEL_ONBOARDING.SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
        isError: false,
      };

    case CANCEL_ONBOARDING.ERROR:
      return {
        ...state,
        isError: action.payload,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };

    default: {
      return state;
    }
  }
};
